import { useState, useEffect } from "react";

import Box from "@mui/material/Box";

import { CommonFooter } from "../Common/CommonFooter";
import { LatLngSearch } from "./LatLngSearch";

export default function Location() {
  const [position, setPosition] = useState({ latitude: null, longitude: null });

  // title
  // const title = "位置情報から検索";
  // document.title = title;
  console.log("位置情報から検索する");

  useEffect(() => {
    //   // GA4
    //   window.gtag('js', new Date());
    //   window.gtag('event', 'page_view', { page_title: title, page_location: location.pathname + location.search })
    //   window.gtag('config', 'G-L8YDJSX9JX');
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setPosition({ latitude, longitude });
      });
    }
  }, []);

  return (
    <>
      <main>
        {(!position.latitude || !position.longitude) && (
          <Box sx={{ m: 2 }}>位置情報が無効です</Box>
        )}
        {position.latitude && position.longitude && (
          <LatLngSearch position={position} />
        )}
      </main>
      <Box sx={{ my: 2 }}>
        <CommonFooter></CommonFooter>
      </Box>
    </>
  );
}
